import styled from 'styled-components';

export const AuthenticationWrapper = styled.div`
  .text-welcome {
    color: #040308;
    font-style: normal;
    padding-bottom: 60px;
    font-size: 32px;
    font-weight: 700;
    @media (max-width: 1280px) {
      font-size: 24px !important;
      padding-bottom: 30px;
}
    @media (max-width: 1536px) {
      font-size: 30px;
      padding-bottom: 40px;
    }
  }

  .text-title {
    color: #040308;
    font-style: normal;
    font-size: 16px;
    font-weight: 500;
    @media (max-width: 1280px) {
      font-size: 12px !important;
}
    @media (max-width: 1536px) {
      font-size: 14px;
    }
  }
  min-height: 100vh;
  width: 554px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'Inter', sans-serif;

  .ant-input-affix-wrapper .ant-input-suffix {
  position: absolute;
  z-index: 100;
  right:10px;
  top: 50%;
  transform: translateY(-50%);
    @media (max-width: 1280px) {
      right: 6px;
    }
    @media (max-width: 1536px) {
      right: 10px;
    }
  }

.input-password {
  height: 40px;
  position: relative;
    @media (max-width: 1280px) {
    position: absolute;
    top:0;
    left : 0;
      height: 32px !important;
      input {
        padding-left: 10px !important;
        height: 32px !important;
        border-radius: 4px;
        font-size: 12px;
      }
    }
    @media (max-width: 1536px) {
      height: 36px;
      border-radius: 6px;
      input {
          height: 36px ;
          border-radius: 6px;
      }
    }
      
  }

  .ant-form-item .ant-form-item-control-input {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 40px;
  }

  @media (max-width: 1536px) {
    .ant-form-item .ant-form-item-control-input {
      max-height: 36px;
      min-height: 36px;
    }
  }

  @media (max-width: 1280px) {
    .ant-form-item .ant-form-item-control-input {
      max-height: 32px;
      min-height: 32px;
    }
  }

  .ant-form-item-control-input-content {
    @media (max-width: 1280px) {
      height: 32px !important;
      input {
        position: absolute;
        top:0;
        left : 0;
        height: 32px !important;
        border-radius: 4px;
        font-size: 12px;0
      }
    }
    @media (max-width: 1536px) {
      height: 34px;
      input {
          height: 36px ;
          border-radius: 6px;
      }

      .ant-input {
        position: absolute;
        top:0;
        left : 0;
        padding-left: 10px !important;
      }
    }

     
  .btn-back {
    width: 100%;

    font-size: 16px;
    font-weight: 600;
  }



  @media (min-width: 1536px) {
    .text-welcome {
      font-size: 36px;
      padding: 10px 0;
    }
  }

  .btn-login {
    width: 100% !important;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }

  .btn-auth-submit {
  width: 100% !important;
  }

  .btn-sign-up,
  .btn-forgot {
    color: #00805a;
    cursor: pointer;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .btn-forgot {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
    color : #00805A !important;
  }
  }

  .ant-form-item .ant-form-item-explain-error {
      @media (min-width : 1280px) and (max-width : 1536px) {
          font-size : 13px
      } 

      @media (max-width : 1280px) {
          font-size : 12px
      } 
}
`;

export const ResetPasswordWrapper = styled.div`
  .ant-form-item-additional {
     @media (max-width: 1536px) {
        margin-top : 6px;
        }
    }

  .text-welcome {
    color: #040308;
    font-style: normal;
    padding-bottom: 10px;
    font-size: 32px;
    font-weight: 700;
    @media (max-width: 1280px) {
      font-size: 24px !important;
}
    @media (max-width: 1536px) {
      font-size: 30px !important;
    }
  }

  .text-title {
    color: #040308;
    font-style: normal;
    font-size: 16px;
    font-weight: 500;
    @media (max-width: 1280px) {
      font-size: 12px !important;
}
    @media (max-width: 1536px) {
      font-size: 14px;
    }
  }
  min-height: 100vh;
  width: 554px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'Inter', sans-serif;

  .ant-input-affix-wrapper .ant-input-suffix {
  position: absolute;
  z-index: 100;
  right:10px;
  top: 50%;
  transform: translateY(-50%);
    @media (max-width: 1280px) {
      right: 6px;
    }
    @media (max-width: 1536px) {
      right: 10px;
    }
  }

.input-password {
  height: 40px;
  position: relative;
    @media (max-width: 1280px) {
    position: absolute;
    top:0;
    left : 0;
      height: 32px !important;
      input {
        padding-left: 10px !important;
        height: 32px !important;
        border-radius: 4px;
        font-size: 12px;
      }
    }
    @media (max-width: 1536px) {
      height: 36px;
      border-radius: 6px;
      input {
          height: 36px ;
          border-radius: 6px;
      }
    }
      
  }

  .ant-form-item .ant-form-item-control-input {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 40px;
  }

  @media (max-width: 1536px) {
    .ant-form-item .ant-form-item-control-input {
      max-height: 36px;
      min-height: 36px;
    }
  }

  @media (max-width: 1280px) {
    .ant-form-item .ant-form-item-control-input {
      max-height: 32px;
      min-height: 32px;
    }
  }

  .ant-form-item-control-input-content {
    @media (max-width: 1280px) {
      height: 32px !important;
      input {
        position: absolute;
        top:0;
        left : 0;
        height: 32px !important;
        border-radius: 4px;
        font-size: 12px;0
      }
    }
    @media (max-width: 1536px) {
      height: 34px;
      input {
          height: 36px ;
          border-radius: 6px;
      }

      .ant-input {
        position: absolute;
        top:0;
        left : 0;
        padding-left: 10px !important;
      }
    }

     
  .btn-back {
    width: 100%;

    font-size: 16px;
    font-weight: 600;
  }



  @media (min-width: 1536px) {
    .text-welcome {
      font-size: 36px;
      padding: 10px 0;
    }
  }

  .btn-login {
    width: 100% !important;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }

  .btn-auth-submit {
  width: 100% !important;
  }

  .btn-sign-up,
  .btn-forgot {
    color: #00805a;
    cursor: pointer;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .btn-forgot {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
    color : #00805A !important;
  }
  }

  .ant-form-item .ant-form-item-explain-error {
      @media (min-width : 1280px) and (max-width : 1536px) {
          font-size : 13px
      } 

      @media (max-width : 1280px) {
          font-size : 12px
      } 
}
`;

export const ResetPasswordSuccessWrapper = styled.div`
  width: 754px;
  // gap: 100px;
  font-family: 'Inter', sans-serif;
  margin: 20% auto;

  .btn-login {
    width: 100%;
    border-radius: 5px;
    background: #48d3d3;
    color: #fff;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 10px;
    height: fit-content;
  }
  .message {
    color: #040308;
    text-align: center;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    margin-top: 20px;

    line-height: normal;
  }
  .iconSuccess {
    display: flex;
    justify-content: center;
  }
  .iconSuccess > div {
    width: 100px;
    height: 100px;
    border-radius: 100px;
    background: rgba(52, 168, 83, 0.05);
    border: none;
  }
`;
